import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { useLanguage } from '../API/Context/LanguageContext';
import { META_MAP } from '../ConfigFiles/meta/meta_config';

const SEOHandler = () => {
  const { pathname } = useLocation();
  const { lan } = useLanguage();

  useEffect(() => {
    // 1. Find the matching metadata by comparing pattern to current path
    const activeRouteKey = Object.keys(META_MAP).find(routePath => 
      matchPath({ path: routePath, end: false }, pathname)
    );

    const meta = META_MAP[activeRouteKey];

    const handleRobots = (noIndex) => {
        let robots = document.querySelector('meta[name="robots"]');
        if (noIndex) {
          if (!robots) {
            robots = document.createElement('meta');
            robots.name = "robots";
            document.head.appendChild(robots);
          }
          robots.content = "noindex, nofollow";
        } else if (robots) {
          robots.remove();
        }
    };

    if (meta) {
      document.title = meta.titles[lan] || "MedCleir";
      handleRobots(meta.noIndex);
    } else {
      // 🎯 Truly no match found in our config
      const errorMeta = META_MAP["404"];
      document.title = errorMeta.titles[lan] || errorMeta.titles[0];
      handleRobots(true);
    }
  }, [pathname, lan]);

  return null;
};

export default SEOHandler;